
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/claims",
      function () {
        return require("private-next-pages/fr/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/claims"])
      });
    }
  